import { shallowMount } from "@vue/test-utils";
import AppFooter from "@/components/core/AppFooter";

describe("AppFooter component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(AppFooter);
  });

  it("Renders del component AppFooter", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
